import request from '@/utils/request'

export function  wodePoints(data) {
  return request({
    url: '/invitation/type',
    method: 'get',
  })
}
export function Yuyanlies(data) {//
 return request({
    url: `/aggregation/goods/${data.id}/language `,
	// url:'/video/page',
    method: 'get'
  })
}
// export function Giftcards(data) {//礼品卡
//   return request({
//     url: '/IntegralMall/giftCards',
//     method: 'post',
// 	data:data
//   })
// }
export function Giftcards(data) {//礼品卡,商品列查询
  return request({
    url: '/IntegralMall/cards',
    method: 'post',
	data:new URLSearchParams(data).toString()
  })
}
export function CommodityPlus(data) {//实物商品列
  return request({
    url: '/CommodityPlus',
    method: 'get',
  })
}
export function addresslist(data) {//实物商品列
  return request({
    url: `/mall/address/list/search`,
    method: 'post',
	data:data
  })
}

export function dizhiadd(data) {//地址添加
  return request({
    url: `/mall/address/add`,
    method: 'post',
	data:data
  })
}
export function dizhiupdate(data) {//地址修改
  return request({
    url: `/mall/address/update`,
    method: 'post',
	data:data
  })
}
export function dizhideleted(data) {//地址修改
  return request({
    url: `/mall/address/deleted/${data.id}`,
    method: 'delete'
  })
}
export function spxiangqin(data) {//购买商品详情
  return request({
    url: `/IntegralMall/info/${data.id}`,
    method: 'get'
  })
}
export function spxiangqin2(data) {//购买商品详情
  return request({
    url: `/CommodityPlus/search/${data.id}`,
    method: 'get'
  })
}
export function juhechangpinxiangqing(data) {//购买商品详情
  return request({
    url: `/aggregation/goods/${data.id}?language=${data.language}`,
    method: 'get'
  })
}
export function Aggregationsx(data) {//产品语言筛
 return request({
   url: `/aggregation/goods?title=${data.title}&language=${data.language}`,
	// url:'/video/page',
   method: 'get'
  })
}
export function lpkduihuan(data) {//礼品卡兑换
  return request({
    url: `IntegralMall/${data.id}`,
    method: 'get'
  })
}
export function pluslpkduihuan(data) {//plus礼品卡兑换
  return request({
    url: `IntegralMall/plus/${data.id}`,
    method: 'get'
  })
}
export function swpduihuan(data) {//实物商品兑换
  return request({
    url: `/IntegralMall/entity/${data.id}/${data.addressId}`,
    method: 'get'
  })
}
export function pkswpduihuan(data) {//实物商品兑换
  return request({
    url: `/IntegralMall/hkplus`,
	method: 'post',
	data:data
  })
}
  
export function shipinduihuan(data) {//付费视频兑换
  return request({
    url: `/IntegralMall/video/${data.id}`,
    method: 'get'
  })
}
export function duihuanjilu(data) {//兑换记录
  return request({
	 url: `/point/history?pageNum=${data.pageNum}&pageSize=${data.pageSize}&keyword=${data.keyword}&day=${data.day}`,
    method: 'GET',
  })
}
export function ybduihuanjilu(data) {//兑换记录
  return request({
	 url: `/warranty/history?pageNum=${data.pageNum}&size=${data.pageSize}`,
    method: 'GET',
  })
}
export function duihuanjilu3(data) {//兑换记录
  return request({
	  url: `/IntegralMall`,
	  method: 'post',
  })
}
// /IntegralMall/
export function yanbaojiage(data) {//查询延保产品续保价格
  return request({
	 url: `/warranty/getPriceSet`,
	 method: 'post',
	 data:new URLSearchParams(data).toString()
  })
}
export function yanbaodaoqishijian(data) {//查询延保产品到期时间
  return request({
	 url: `/warranty/getDueTime`,
	 method: 'post',
	 data:new URLSearchParams(data).toString()
  })
}
export function yanbaolishi(data) {//查询用户购买延保历史
  return request({
	 url: `/warranty/history`,
	 method: 'post',
	 data:data
  })
}
export function yanbaogoumai(data) {//购买延保
  return request({
	 url: `/warranty/save`,
	 method: 'post',
	 data:data
  })
}